import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ClearIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { Box } from '@mui/system';
import { IconButton } from '@mui/material';
import { PickerValue } from '@mui/x-date-pickers/internals';
import { useEffect, useState } from 'react';

interface Props {
  label: string;
  defaultValue?: string | undefined | null;
  onDatePick?: (date: string | undefined) => void;
  allowCancel?: string;
  bindError?: () => { error?: boolean; helperText?: string };
  disableKeyDown?: boolean; //prevents from manual date input
}

export const InputDatePicker = ({ defaultValue, label, onDatePick, allowCancel, bindError, disableKeyDown }: Props) => {
  const [value, setValue] = useState<Dayjs | null>(null);

  useEffect(() => {
    if (dayjs(defaultValue).isValid()) {
      setValue(dayjs(defaultValue));
    }
  }, [defaultValue]);

  const handleChange = (date: PickerValue) => {
    setValue(date);
    onDatePick?.(date?.format('YYYY-MM-DD'));
  };

  const preventKeydown = (e: React.KeyboardEvent<HTMLElement>) => e.preventDefault();

  const clearValue = () => onDatePick?.(undefined);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box display="flex" alignItems="center" gap={2} height={'100%'}>
        <DatePicker
          label={label}
          value={value}
          format="DD-MM-YYYY"
          onChange={handleChange}
          sx={{ width: '100%' }}
          slotProps={{
            textField: {
              ...bindError?.(), //useForm error handler
              InputProps: {
                readOnly: disableKeyDown,
                onKeyDown: disableKeyDown ? preventKeydown : undefined, //prevents every keyboard input
              },
              InputLabelProps: { shrink: true },
            },
          }}
        />
        {allowCancel && (
          <IconButton onClick={clearValue}>
            <ClearIcon />
          </IconButton>
        )}
      </Box>
    </LocalizationProvider>
  );
};
